if (!customElements.get("nss-tabs")) {
    customElements.define("nss-tabs", class NSSTabs extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                tablist: ".js-nss-tabs-tablist",
                tabs: ".js-nss-tabs-tab",
                tabpanels: ".js-nss-tabs-tabpanel"
            };
            this.tablist = this.querySelector(this.selectors.tablist);
            this.tabs = Array.from(this.querySelectorAll(this.selectors.tabs));
            this.tabpanels = Array.from(this.querySelectorAll(this.selectors.tabpanels));
            this.orientation = this.tablist.getAttribute("aria-orientation");
            this.focusedTabIndex = 0;

            this.init();
        }

        init() {
            // Add keydown event listeners for tab navigation
            this.tablist.addEventListener("keydown", this.handleKeydown.bind(this));

            // Add click event listener to tabs using delegation
            this.tablist.addEventListener("click", this.handleTabClick.bind(this));

            this.selectTabInit(0);
        }

        handleKeydown(e) {
            const horizontalKeys = {
                ArrowLeft: () => this.selectPreviousTab(),
                ArrowRight: () => this.selectNextTab(),
            };

            const verticalKeys = {
                ArrowUp: () => this.selectPreviousTab(),
                ArrowDown: () => this.selectNextTab(),
            };

            const commonKeys = {
                Home: () => this.selectFirstTab(),
                End: () => this.selectLastTab(),
            };

            // Prevent default for navigation keys
            if (e.key in commonKeys || (this.orientation === "vertical" && e.key in verticalKeys)) {
                e.preventDefault();
            }

            // Call corresponding handler
            const keyHandlers = {
                ...commonKeys,
                ...(this.orientation === "vertical" ? verticalKeys : horizontalKeys),
            };

            if (keyHandlers[e.key]) keyHandlers[e.key]();
        }

        handleTabClick(e) {
            const clickedTab = e.target.closest(this.selectors.tabs);

            if (clickedTab) {
                const index = this.tabs.indexOf(clickedTab);
                this.selectTab(index);
            }
        }
        selectTabInit(index){
            this.tabs.forEach((tab, i) => {
                const isSelected = i === index;
                tab.setAttribute("aria-selected", isSelected);
                tab.setAttribute("tabindex", isSelected ? "0" : "-1");
            });

            this.tabpanels.forEach(panel => panel.classList.remove("is-visible"));

            // Activate selected tab and panel
            const selectedTab = this.tabs[index];
            const panelId = selectedTab.getAttribute("aria-controls");
            this.querySelector(`#${panelId}`).classList.add("is-visible");

            if(selectedTab.hasAttribute("data-parent")){
                document.querySelector(`.${selectedTab.getAttribute("data-parent")}`)?.setAttribute("data-active",index );
            }
        }

        selectTab(index) {
            this.selectTabInit(index);
            const selectedTab = this.tabs[index];
            selectedTab.focus();
            this.focusedTabIndex = index;
        }

        selectPreviousTab() {
            const index = (this.focusedTabIndex - 1 + this.tabs.length) % this.tabs.length;
            this.selectTab(index);
        }

        selectNextTab() {
            const index = (this.focusedTabIndex + 1) % this.tabs.length;
            this.selectTab(index);
        }

        selectFirstTab() {
            this.selectTab(0);
        }

        selectLastTab() {
            this.selectTab(this.tabs.length - 1);
        }
    });
}